import log from 'loglevel';
import React from 'react';
import { usePlayerContext } from '../Context';

const Title = () => {
  const { sdk } = usePlayerContext();

  const prefix = sdk.getClassNamePrefix();
  const title = sdk.options().getTitle() as string;

  if (!title) return null;

  return (
    <div
      className={`${prefix}-player-control ${sdk.getClassNamePrefix()}-player-control-title`}
      dangerouslySetInnerHTML={{ __html: title }}
    />
  );
};

export default Title;
